(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SectorDeleteController',SectorDeleteController);

    SectorDeleteController.$inject = ['$uibModalInstance', 'entity', 'Sector'];

    function SectorDeleteController($uibModalInstance, entity, Sector) {
        var vm = this;
        vm.sector = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Sector.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
